import React, {useState} from "react";
import { useLocation } from "react-router-dom";
import { AppRegistry,StyleSheet,Text, View, Button,TextInput, CheckBox,  KeyboardAvoidingView,
    ScrollView,
    SafeAreaView,Dimensions} from "react-native";
	import { AutocompleteDropdown } from 'react-native-autocomplete-dropdown'
import  { Component } from 'react';
import firebase from './database/firebase';
const Infoo = (props) => {
	const [selectedLanguage, setSelectedLanguage] = useState('choose');
	const [scroll, setScroll] = useState(true);
	const [placeh, setPlaceh] = useState('Enter your language');
	const [selectedItem, setSelectedItem] = useState(null);
	const [showAlert, setShowAlert] = useState(1);
    return(       
			<View style={styles.container}>
				
				<Text style={styles.text}>Social Media Post Translation Experiment</Text>
                <Text style={styles.text}> </Text>
                <Text style={styles.text}>Welcome!</Text>
                <Text style={styles.text2}>Please select the language you want to use to write your post:</Text>			
				<SafeAreaView
					style={{
					marginBottom: 30,
					marginTop: 30,
					textAlign: 'center',
                    flexDirection: "column",
                    paddingLeft: Dimensions.get('window').width/4.5,
                    paddingRight: Dimensions.get('window').width/4.5,
                    paddingBottom: 50,
                    justifyContent: "center",                   
                    }}>
					      <AutocompleteDropdown
     // clearOnFocus={false}
      //closeOnBlur={true}
      //closeOnSubmit={false}
      //initialValue={{ id: "0" }}
      onSelectItem={(item) => {
      item; setSelectedItem(item);
      }}
      textInputProps={{
        placeholder: 'Enter your language',
        autoCapitalize: "none",
        style: {
          borderRadius: 25,
          backgroundColor: "#383b42",
          color: "#fff",
          paddingLeft: 18
        }
      }}
      inputHeight={50}
	  dataSet={[
        { id: '1', title: 'Chinese' },
        { id: '2', title: 'Dutch' },
        { id: '3', title: 'French',id:'fr' },
        { id: '4', title: 'German' },
		{ id: '41', title: 'Other Language' },
      ]}    />
				</SafeAreaView>
			
					
				<Text style={styles.text4}>On the next page you will be given a prompt to write a social media post/status update.</Text>
                <Text style={styles.text4}>Press 'Start' button to begin the experiment</Text>
				<View style={styles.buttonContainer}>
                <Button 
                color='#341ada'
                title="Start"
                style={StyleSheet.buttonStyle}
                onPress={() => {
					if(selectedItem === null){
							alert('Please choose a language before starting the experiment');
						}
					else{
						if(selectedItem.id ==='41')
						{
							if(showAlert ===0)
							{
								alert("sorry, we don't support other languages! Unfortunately, we will have to end your experiment.");
								props.navigation.navigate('Fin')
							}
							else
							{
								setShowAlert(0);
								alert("sorry, we don't support other languages! Please choose language from the drop-down list");
							} 
						}
						else
						{
							firebase.database().ref('participants/' + props.navigation.state.params.uid).set({
								
								language: selectedItem.title,
								langid:selectedItem.id,
								userId: props.navigation.state.params.uid,
							});
						props.navigation.navigate('Fasla', {uid:props.navigation.state.params.uid,language: selectedItem.title,langid:selectedItem.id,});
						}
						/*if(selectedLanguage === 'no')
						{
							alert('Sorry you are not eligible to take the experiment!');
						}
						else{
					
						props.navigation.navigate('Main', {language: selectedItem.title});
						}*/
					}
					}}
				> 
                </Button>
				</View>
			</View>
       
    )
}
const styles = StyleSheet.create({
	container: {
		padding: 5,
		flex: 1,
		display: "flex",
		marginTop: 5,
		textAlign: 'center',
		flexDirection: "column",
        //backgroundColor:'#D3D3D3',
		justifyContent: "center",
	},
	imageContainer: {
		padding: 20,
		marginTop: 10,
		marginBottom: 20,
		textAlign: 'center',
        flexDirection: "row",
        paddingLeft: 100,
		paddingRight: 100,
        justifyContent: "center",
		
	},
	buttonContainer:{
		width: '20%',
		alignSelf: 'center',
		marginVertical: 20,
	},

	text: {
		fontWeight: "bold",
		fontSize: 40
	},
    text2: {
		
		fontSize: 20,
        marginTop: 90,        
        marginBottom: 20,        
        textAlign: 'center',
	},
    text3: {
		//fontWeight: "bold",
		padding: 10,
		fontSize: 18,
	},
    
    text4: {
		//fontWeight: "bold",
		paddingTop:20,
		padding: 30,
		fontSize: 18,
	},
	buttonStyle: {
	alignItems: 'center',
	justifyContent: 'center',
	paddingVertical: 52,
	paddingHorizontal: 32,
	borderRadius: 0,
	elevation: 13,
	backgroundColor:"#341ada"
	},
	listContainer: {
		paddingTop: 20
	},
	listItem: {
		fontSize: 20
	},
	textAreaContainer: {		
		paddingTop: 30,
		width: '10%',
		height:'10%',
		//paddingRight:270,
		//paddingLeft: 270,
		//paddingBottom: 30,
	  },
	  checkboxContainer: {
        flexDirection: "row",
        justifyContent: "center",
        marginBottom: 2,
      },
      checkbox: {
        alignSelf: "center",
      },
      label: {
        margin: 8,
        fontWeight: "bold",
        fontSize: 20,
      },
	  textArea: {
		height: 50,
		width:220,
		fontSize: 18,
		//borderColor: '#341ada',
		//borderWidth: 3,
		justifyContent: 'center',
		alignItems: 'center',
		alignSelf: "center",
	  }
})				
export default Infoo
